import BaseModel from "../base_model.js.jsx";
import ListProjectsUseCase from "../../use_cases/admin/projects/projects/list_projects_use_case.js.jsx"
import ListUsersUseCase from "../../use_cases/admin/users/users/list_users_use_case.js.jsx"
import InvestmentStatusEnum from "../../enums/investment_status.js.jsx";
import InvestmentActivityStatusEnum from "../../enums/investment_activity_status.js.jsx";

class RawProjectCreateInvestmentModel extends BaseModel {
  rawFormFields(item = undefined) {
    return [
      {
        name: "participant_project",
        displayName: this.fieldDisplayName("project"),
        type: "model",
        useCase: ListProjectsUseCase,
        foreignKey: "projectId",
        allowClear: true,
      },
      {
        name: "amount",
        displayName: this.fieldDisplayName("amount"),
        type: "decimal",
      },
      {
        name: "bonus_rate",
        displayName: this.fieldDisplayName("bonus_rate"),
        type: "decimal",
      },
      {
        name: "interest_rate",
        displayName: this.fieldDisplayName("interest_rate"),
        type: "decimal",
      },
      {
        name: "end_date",
        displayName: this.fieldDisplayName("end_date"),
        type: "dateTime",
        format: "DD.MM.YYYY",
      },
      {
        name: "bonuscode",
        displayName: this.fieldDisplayName("bonuscode"),
        type: "text",
      },
      {
        name: "status",
        displayName: this.fieldDisplayName("status"),
        type: "enum",
        enum: InvestmentStatusEnum,
      },
      {
        name: "activityStatus",
        displayName: this.fieldDisplayName("activityStatus"),
        type: "enum",
        enum: InvestmentActivityStatusEnum,
      },
    ]
  }

  i18nScope() {
    return "model.projects.investment";
  }

}
const ProjectCreateInvestmentModel = new RawProjectCreateInvestmentModel();

export { RawProjectCreateInvestmentModel, ProjectCreateInvestmentModel }
